import { FaHandshake, FaHeadset, FaExclamationTriangle } from "react-icons/fa";
import { companyInfo } from "../data/companyInfo";

const NotAPartnerYetScreen = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10 dark:bg-slate-950">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm sm:p-10 dark:border-slate-800 dark:bg-slate-900">
        {/* Main Icon */}
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-rose-50 dark:bg-rose-950/40">
          <FaHandshake className="text-4xl text-rose-700 dark:text-rose-400" />
        </div>

        {/* Status */}
        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-amber-50 px-3 py-1.5 text-xs font-medium text-amber-700 dark:bg-amber-950/40 dark:text-amber-300">
          <FaExclamationTriangle />
          Partner onboarding required
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl dark:text-white">
          You're Not Onboarded Yet
        </h1>

        <p className="mx-auto mt-4 max-w-md text-sm leading-6 text-slate-600 sm:text-base dark:text-slate-300">
          You are not onboarded as a <strong>WaBM/Wabmate partner</strong> yet.
          Please contact our support team for more information and assistance
          with onboarding.
        </p>

        {/* Actions */}
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <a
            href={`https://api.whatsapp.com/send?phone=${companyInfo?.supportContact}`}
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-rose-800 px-5 py-3 text-sm font-semibold text-white transition hover:bg-rose-900 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2"
          >
            <FaHeadset className="text-base" />
            Contact Support
          </a>
        </div>

        <p className="mt-6 text-xs text-slate-400">
          WaBM / Wabmate Partner Program
        </p>
      </div>
    </div>
  );
};

export default NotAPartnerYetScreen;
